import './index.css'
import Lottie from 'react-lottie';
import animationData from '../../keksAnimation'
import { isMobile } from 'react-device-detect'

const defaultOptions = {
      loop: true,
      autoplay: true, 
      animationData: animationData,
      rendererSettings: {
          preserveAspectRatio: 'xMidYMid slice'
      }
}

const Loading = () => {
  return (
    <div className="loading">
        <Lottie options={defaultOptions} height={!isMobile?600:300} width={!isMobile?600:300}/> 
    </div>
  )
}

export default Loading
